import envCodes from '@/assets/js/envCodes'
import productUtils from '@/core/productUtils'
import productList from './list'
import Utils from '@/core/utils'
const UNIT_TIME_MAP = {
  'm³/h': 1,
  'L/s': 1 / 3.6
}
const state = {
  ...productList.state,
  convertUnits: [{ code: 'P000007', unit: 'm³/h', times: 1, prop: 'fluid' }], // 需要转换单位的集合
}
const getters = {
  ...productList.getters,
  // 性能筛选条件中的必填曲线属性
  curveFormItems: (state) => {
    const allProps = state.allProperties || []
    const specUnits = state.convertUnits || []
    const formItemsCodes = ['fluid', 'head']
    const res = []
    formItemsCodes.forEach((item) => {
      const code = envCodes[item]
      const prop = allProps.find((it) => it.code === code) || {}
      const propSpecUnit = specUnits.find((it) => it.code === code) || {}
      item === 'fluid' ? res.push({
        label: prop.name,
        code: prop.code,
        dataType: prop.dataType,
        suffix: propSpecUnit.unit || prop.unitSymbol,
        suffixes: ['m³/h', 'L/s'],
        required: true,
      }) : res.push({
        label: prop.name,
        code: prop.code,
        dataType: prop.dataType,
        suffix: prop.unitSymbol,
        required: true,
        val: '',
      })
    })
    return res
  },
  // 用于展示的列表数据
  tableData: (state) => {
    const list = state.products
    const samplesMapping = state.samplesMapping
    const data = []
    list.forEach((item) => {
      const productProps = item.productPropertyValues || []
      const productPropsObj = productUtils.handleProductPropertiesData({ productsData: productProps, category: 'pump' })
      const sampleMap = samplesMapping.find((s) => s.productId === item.id) || {}
      const obj = {
        id: item.id,
        sampleId: sampleMap.sampleId,
        brandCode: item.brandCode,
        brandName: item.brandName,
        model: item.model,
        name: item.name,
        imageUrl: item.imageUrl,
        productSeriesId: item.productSeriesId,
        productSeriesName: item.productSeriesName,
        ...productPropsObj
      }
      // 值根据times进行对应转换
      const units = state.convertUnits
      units.forEach((u) => {
        const prop = u.prop
        const times = u.times
        const value = obj[prop]
        obj[`${prop}Fmt`] = times === 1 ? value : Utils.timesValue(value, times, 2)
      })
      data.push(obj)
    })
    return data
  },
  convertUnits: (state) => state.convertUnits
}
const mutations = {
  ...productList.mutations,
  updateUnit(state, item) {
    const units = state.convertUnits
    const specUnit = units.find((u) => u.code === item.code)
    if (specUnit) {
      specUnit.unit = item.suffix
      specUnit.times = UNIT_TIME_MAP[item.suffix]
    }
  }
}
const actions = {
  ...productList.actions,
}
export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
